import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EventBatchFields from './StudentEnrollmentBatchFields'

export const StudentEnrollmentBatchCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <EventBatchFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default StudentEnrollmentBatchCreate
